"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AppTheme = _interopRequireDefault(require("./AppTheme"));

var _AppBase = _interopRequireDefault(require("./AppBase"));

var _AppNav = _interopRequireDefault(require("./AppNav"));

var _AppHeader = _interopRequireDefault(require("./AppHeader"));

var _AppBody = _interopRequireDefault(require("./AppBody"));

var _AppSidebar = _interopRequireDefault(require("./AppSidebar"));

var _AppContent = _interopRequireDefault(require("./AppContent"));

var _NavAction = _interopRequireDefault(require("../NavAction/NavAction"));

var _NavMenu = _interopRequireDefault(require("../NavMenu/NavMenu"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const useStyles = (0, _styles.makeStyles)(theme => ({
  header: {
    position: "absolute",
    zIndex: 2,
    top: 0,
    right: 0,
    bottom: 'auto',
    left: 0,
    height: theme.spacing(8),
    overflow: "hidden",
    marginTop: theme.spacing(-8),
    transition: ".125s ease-out",
    "&[aria-expanded=true]": {
      marginTop: 0
    }
  },
  nav: {
    position: "absolute",
    zIndex: 2000,
    top: 0,
    right: 0,
    marginTop: theme.spacing(-8),
    transition: ".125s ease-out",
    "&[aria-expanded=true]": {
      marginTop: 0
    },
    height: theme.spacing(8),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    "& > button": {}
  },
  body: {
    position: "absolute",
    zIndex: 1,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    marginTop: theme.spacing(8),
    transition: ".125s ease-out",
    "&[aria-expanded=true]": {
      marginTop: 0
    }
  },
  sidebar: {},
  sidebarAction: {
    position: "relative",
    zIndex: 2,
    margin: "24px"
  },
  sidebarMenu: {
    position: "absolute",
    zIndex: 1,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    paddingTop: "84px",
    marginRight: "16px",
    marginLeft: "0",
    overflowY: "scroll"
  }
}));

const LayoutApp = ({
  theme,
  app = {},
  menuByUrl = {},
  user,
  owner,
  nav = {},
  header = {},
  sidebar = {},
  search = {},
  subview = {},
  onToggle,
  onSelect,
  onLogin,
  onLogout,
  children
}) => {
  header = _extends({
    title: app && app.title,
    subtitle: owner && owner.title || user && user.name
  }, header);
  sidebar = _extends({}, app.sidebar, {}, sidebar);
  const primaryAction = app && app.primaryAction;
  const menu = app && app.menu;
  search = _extends({}, app.search, {}, search);
  nav = {
    app: app,
    user: user,
    owner: owner
  };

  if (search && search.expanded) {
    nav.expanded = false;
  }

  if (subview && subview.expanded) {
    nav.expanded = false;
  }

  const classes = useStyles({
    header
  });
  return _react.default.createElement(_AppTheme.default, {
    theme: theme || app && app.theme
  }, _react.default.createElement(_AppBase.default, null, _react.default.createElement(_AppHeader.default, _extends({
    className: classes.header
  }, header, {
    search: search,
    subview: subview,
    onToggle: onToggle
  }), _react.default.createElement(_AppNav.default, _extends({}, nav, {
    onLogin: onLogin,
    onLogout: onLogout,
    onSelect: onSelect
  }))), _react.default.createElement(_AppBody.default, {
    className: classes.body,
    expanded: header && !header.expanded && true
  }, sidebar && _react.default.createElement(_AppSidebar.default, sidebar, primaryAction && _react.default.createElement(_NavAction.default, {
    className: classes.sidebarAction,
    primaryAction: primaryAction,
    placement: "bottom-start",
    onSelect: onSelect
  }), menu && _react.default.createElement(_NavMenu.default, {
    className: classes.sidebarMenu,
    menu: menu,
    menuByUrl: menuByUrl,
    onSelect: onSelect
  }), sidebar.children && sidebar.children), _react.default.createElement(_AppContent.default, null, children))));
};

LayoutApp.defaultProps = {
  app: {},
  header: {
    expanded: true
  },
  nav: {
    expanded: true
  }
};
LayoutApp.propTypes = process.env.NODE_ENV !== "production" ? {
  app: _propTypes.default.node,
  user: _propTypes.default.node,
  owner: _propTypes.default.node,
  menuByUrl: _propTypes.default.object,
  header: _propTypes.default.node,
  search: _propTypes.default.node,
  subview: _propTypes.default.node,
  sidebar: _propTypes.default.node
} : {};
var _default = LayoutApp;
exports.default = _default;
module.exports = exports.default;